module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_30.dot-ede7605441938c8b0c13548b76e5f80d.svg";